import { combineReducers } from "@reduxjs/toolkit";
import isLoading from "./loader.reducer";
import  headerTitle  from "./header.reducer";
import configAction from "./config.reducer";

const rootReducer = combineReducers({
    isLoading,
    headerTitle,
    configAction
});
export default rootReducer